/**
* DevExpress Analytics (query-builder\dataSource\json\jsonAuthenticationInfo.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serializer_1 = require("../../../serializer/serializer");
var JsonAuthenticationInfo = (function () {
    function JsonAuthenticationInfo(model, serializer) {
        serializer = serializer || new serializer_1.ModelSerializer();
        serializer.deserialize(this, model || {});
    }
    JsonAuthenticationInfo.from = function (model, serializer) {
        return new JsonAuthenticationInfo(model, serializer);
    };
    JsonAuthenticationInfo.toJson = function (value, serializer, refs) {
        return serializer.serialize(value, value.getInfo(), refs);
    };
    JsonAuthenticationInfo.prototype.getInfo = function () {
        return [
            { propertyName: 'password', modelName: '@password', defaultVal: '' },
            { propertyName: 'userName', modelName: '@user', defaultVal: '' }
        ];
    };
    return JsonAuthenticationInfo;
}());
exports.JsonAuthenticationInfo = JsonAuthenticationInfo;
